import {
    INTAKE_LIST_REQUEST,
    INTAKE_LIST_SUCCESS,
    INTAKE_LIST_FAIL
} from '../constants/intakeConstants'

export const intakeListReducer = (state = {}, action) => {
    switch (action.type) {
        case INTAKE_LIST_REQUEST:
            return { loading: true }
        case INTAKE_LIST_SUCCESS:
            return { loading: false, intakes: action.payload }
        case INTAKE_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

